import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';

import { useJobArchitectureItemPath } from '../../api/use-job-architecture-item-path';
import { SkeletonBreadcrumbs } from '../../components/SkeletonLoaders';
import { ProfileBreadcrumbs } from '../../job-profile-section/ProfileBreadcrumbs';
import type { ProfileTaskParentContext } from '../model/profile-task';
import { profileTaskTranslationKeys } from '../profile-task-translations';

export const ProfileTaskBreadcrumbs: FunctionComponent<{
    readonly className?: string;
    readonly context: ProfileTaskParentContext;
    readonly currentItemTitle?: string;
}> = ({ className, context, currentItemTitle }) => {
    const translate = useTranslate();
    const { data: itemPath, isLoading } = useJobArchitectureItemPath(context.architectureId, context.parentId);
    const clusterId = itemPath?.cluster;
    const familyId = itemPath?.family;

    if (isLoading) {
        return (
            <div className={className}>
                <SkeletonBreadcrumbs />
            </div>
        );
    }

    if (!is.nonEmptyString(clusterId) || !is.nonEmptyString(familyId)) {
        return null;
    }

    return (
        <div className={className} data-testid="profile-task-breadcrumbs">
            <ProfileBreadcrumbs
                architectureId={context.architectureId}
                clusterId={clusterId}
                currentItemTitle={currentItemTitle ?? translate(profileTaskTranslationKeys.breadcrumb)}
                familyId={familyId}
                parentRoleId={context.parentType === 'role' ? context.parentId : (itemPath?.role ?? context.roleId)}
            />
        </div>
    );
};
